/* @flow */
import activityRecipientsSaga from 'payments/sagas/activityRecipients';
import connectedBankAccountRequest from 'payments/sagas/connectedBankAccountRequest';
import roleBasedMessagingSearchSaga from 'sagas/roleBasedMessagingSearch';
import organizationClasses from 'sagas/organizationClasses';
import loadAvailableReactions from 'sagas/availableReactions';
import loadQuickActions from 'sagas/quickActions';
import peopleTables from 'sagas/peopleTables';
import schoolTables from 'sagas/schoolTables';

export default function* rootSaga(): Generator<?any, ?any, ?any> {
  yield [
    activityRecipientsSaga(),
    connectedBankAccountRequest(),
    roleBasedMessagingSearchSaga(),
    loadAvailableReactions(),
    organizationClasses(),
    loadQuickActions(),
    peopleTables(),
    schoolTables(),
  ];
}



// WEBPACK FOOTER //
// ./src/sagas.js